import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Card, CardActions, CardContent, Typography } from '@mui/material';
import { parsePrice } from 'src/utils/parse-price';
import { useTranslation } from 'react-i18next';

export default function ChoosePriceDialog({openChoosePriceDialog, handleChoosePriceDialogClose, pricesData, handleSubscribe, choosePriceMode}) {

  const { t } = useTranslation()
  
  const getBillingType = (type) => {
    switch (type){
        case 'month':
            return t("views.subscriptions.monthly")
        case 'year': 
            return t("views.subscriptions.annual")
        case 'week':
            return 'Weekly'
        case 'day':
            return 'Daily'
    }
  }

  return (
      <Dialog
        open={openChoosePriceDialog}
        onClose={handleChoosePriceDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" textAlign="center">
          {t("views.subscriptions.choosePrice")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" textAlign="center">
            {t("views.subscriptions.chooseBillingMethod")}
          </DialogContentText>
          <Box sx={{display: 'flex', gap: '20px', mt: 3, justifyContent: 'center'}}>
            {pricesData ? pricesData.map(price => { return (
                    <Card sx={{minWidth: '250px'}} key={price.id} variant="outlined">
                        <CardContent sx={{textAlign: 'center'}}>
                            <Typography variant='h5'>{parsePrice(price.unit_amount)} {price.currency.toUpperCase()}</Typography>
                            {price.recurring.interval == 'year' ? (
                              <Typography variant='body2'>{'('}12 x {parsePrice(Math.round(price.unit_amount / 12))}{')'}</Typography>
                            ) : price.recurring.interval == 'month' ? (
                               <Typography variant='body2'>{parsePrice(Math.round(price.unit_amount))} / m</Typography>
                            ) : null}
                            <Typography sx={{ color: 'text.secondary', fontSize: 12, mt: 4}}>{t("views.subscriptions.billingType")}</Typography>
                            <Typography>{getBillingType(price.recurring.interval)}</Typography>
                        </CardContent>
                        <CardActions>
                            <Button variant='contained' fullWidth onClick={(event) => {
                              event.target.disabled = true;
                              handleSubscribe(price.id, choosePriceMode);
                            }}>{t("views.subscriptions.choose")}</Button>
                        </CardActions>
                    </Card>
                )
                }) : null}
          </Box>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleChoosePriceDialogClose}>{t("views.subscriptions.close")}</Button>
        </DialogActions>
      </Dialog>
  );
}